import React from "react";

import { generateMediaUrl } from "../../../helpers/media";
import Link from "../../../components/Link";

import style from "./style.module.css";

export default function Card ({item}) {
    return (
        <div className={style.card}>
            <div className={style.cardInner}>
                {
                    item.sponsor_image !== "" && (
                        <img alt="logo" src={generateMediaUrl(item.sponsor_image, "0x260")} className={style.brandLogo} />
                    )
                }
                {
                    item.sponsor_url !== "" && (
                        <Link to={item.sponsor_url} className={style.fullBlock}></Link>
                    )
                }
            </div>
        </div>
    )
}